
// 生成guid
const generateGUID = () => {
  let d = new Date().getTime()
  if (window.performance && typeof window.performance.now === 'function') {
    d += performance.now()
  }
  const guid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (d + Math.random() * 16) % 16 | 0
    d = Math.floor(d / 16)
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })
  return guid
}
class CommandManage {
  // 撤销列表
  undoList = []
  // 重做列表
  redoList = []
  // 撤销次数限制
  undoCount = 10
  // 执行的步骤
  executeCount = 0
  // 初始数据
  initData = null
  // 初始数据id
  initFlagId = null
  // 是否已经重置
  isReset = true

  // 初始化
  constructor(initData) {
    this.initData = initData
    this.initFlagId = generateGUID()
    this.initData.id = this.initFlagId
  }
  // 执行了操作
  executeCommand(data) {
    this.isReset = false
    this.undoList.push(data)
    this.redoList = []
    if (this.executeCount < this.undoCount) {
      this.executeCount += 1
    }
  }
  // 撤销
  undoCommand() {
    this.isReset = false
    if (this.undoList.length > 0 && this.executeCount >= 1) {
      this.executeCount -= 1
      const data = this.undoList.pop()
      this.redoList.push(data)
      return {
        executeCount: this.executeCount,
        currentData:
          this.undoList.length <= 0 ? this.initData : this.undoList[this.undoList.length - 1],
        undoList: this.undoList,
        redoList: this.redoList,
      }
    }
    return null
  }
  // 重做
  redoCommand() {
    this.isReset = false
    if (this.redoList.length > 0) {
      if (this.executeCount < this.undoCount) {
        this.executeCount += 1
      }
      const data = this.redoList.pop()
      this.undoList.push(data)
      return {
        executeCount: this.executeCount,
        currentData: data,
        undoList: this.undoList,
        redoList: this.redoList,
      }
    }
    return null
  }
  // 重置操作
  resetCommand() {
    this.isReset = true
    if (this.initData) {
      const commandReset = _.find(this.undoList, ['id', this.initFlagId])
      if (_.isNil(commandReset)) {
        this.undoList.push(this.initData)
        if (this.executeCount < this.undoCount) {
          this.executeCount += 1
        }
        return this.initData
      }
      return null
    }
    return null
  }
}
// 计算多个节点的中心，然后移动到其中点
const getMergedItemAabb = async (player, codeLists, documentId) => {
  let AabbItems = []
  for (let i = 0; i < codeLists.length; i++) {
    const resPtr = await PlayerUtils.call(player.Native.ModelTree.calcItemAabb, codeLists[i])
    AabbItems.push({
      x: 1 * resPtr.aabb.min[0] + (resPtr.aabb.max[0] - resPtr.aabb.min[0]) / 2, // x坐标
      y: 1 * resPtr.aabb.min[1] + (resPtr.aabb.max[1] - resPtr.aabb.min[1]) / 2, // y坐标
      z: 1 * resPtr.aabb.min[2] + (resPtr.aabb.max[2] - resPtr.aabb.min[2]) / 2, // z坐标
    })
  }
  const centerPos = await getCenter(AabbItems)
  const modelInfo = await PlayerUtils.call(player.Native.Model.getInfo, documentId)
  player.Native.Camera.moveToPos([centerPos.x, centerPos.y, centerPos.z], modelInfo.nodePtr,500, 1)
}
// 计算多个点的中点
const getCenter = async (points) => {
  const res = {
    x: 0,
    y: 0,
    z:0
  }
  points.forEach((p) => {
    res.x += p.x;
    res.y += p.y;
    res.z += p.z;
  })
  res.x /= points.length
  res.y /= points.length
  res.z /= points.length
  return res
}
export { CommandManage, getMergedItemAabb }
